export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6619.a1dd38f9.jpg";